module.exports = __webpack_public_path__ + "02_long_gold.0d2511c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/02_long_gold.png
// module id = GAm4
// module chunks = 0